/* ============================================================================
  packaging-drawer.js
  <packaging-drawer> は「梱包について」の詳細を右からスライドして表示する
  ドロワーUIを制御するカスタム要素。main-cart-sidebar.liquid の中で
  packaging-drawer.liquid スニペットと組み合わせて使用する。

  オーバーレイとパネルは、祖先要素の重なり文脈（スタッキングコンテキスト）の
  影響を受けないよう、初期化時に document.body 直下へ移動させる。
============================================================================ */

if (!customElements.get('packaging-drawer')) {
  customElements.define(
    'packaging-drawer',
    class PackagingDrawer extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('.cart-sidebar__drawer-trigger');
        this.overlay = this.querySelector('.packaging-drawer__overlay');
        this.closeButton = this.querySelector('.packaging-drawer__close');
        this.panel = this.querySelector('.packaging-drawer__panel');

        if (!this.trigger || !this.panel) return;

        // body 直下に移動する前に、以前（別インスタンスの初期化時）に
        // 同じ処理で body 直下へ移動されたまま残っている古い要素があれば
        // 先に取り除く（自分自身の要素は除く）。ドロワー全体がAJAXで
        // 丸ごと再生成される場合などに、古いパネルが孤立して残り続け、
        // 表示が重複するのを防ぐため。
        document
          .querySelectorAll('.packaging-drawer__overlay, .packaging-drawer__close, .packaging-drawer__panel')
          .forEach((el) => {
            if (el !== this.overlay && el !== this.closeButton && el !== this.panel) {
              el.remove();
            }
          });

        // body 直下に移動し、常に画面全体を基準にfixed表示されるようにする
        // （祖先要素のtransform等に巻き込まれてposition:fixedが
        //   正しく機能しなくなるのを避けるため、それぞれ独立して移動する）
        if (this.overlay) document.body.appendChild(this.overlay);
        if (this.closeButton) document.body.appendChild(this.closeButton);
        document.body.appendChild(this.panel);

        this.trigger.addEventListener('click', this.open.bind(this));
        if (this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));
        if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));

        // オーバーレイのクリックに加えて、ドロワー・トリガー以外の場所を
        // クリックした場合にも確実に閉じるようにする
        document.addEventListener('click', (event) => {
          if (!this.classList.contains('active')) return;
          if (this.panel.contains(event.target)) return;
          if (this.trigger.contains(event.target)) return;
          this.close();
        });

        document.addEventListener('keydown', (event) => {
          if (!this.classList.contains('active')) return;
          if (event.key === 'Escape' || event.key === 'Esc') this.close();
        });

        this.panel.setAttribute('tabindex', '-1');
      }

      open() {
        this.classList.add('active');
        document.body.classList.add('packaging-drawer-open');
        this.trigger.setAttribute('aria-expanded', 'true');

        // PC表示のみ：ヘッダー/告知バーは固定表示ではないため、
        // 開いた瞬間に実際に画面内へ残っている高さ分だけオフセットする
        if (window.matchMedia('(min-width: 990px)').matches) {
          var offset = PackagingDrawer.getVisibleHeaderOffset();
          this.panel.style.top = offset + 'px';
          this.panel.style.height = 'calc(100% - ' + offset + 'px)';
          if (this.overlay) this.overlay.style.top = offset + 'px';
          if (this.closeButton) this.closeButton.style.top = offset + 16 + 'px';
        } else {
          this.panel.style.top = '';
          this.panel.style.height = '';
          if (this.overlay) this.overlay.style.top = '';
          if (this.closeButton) this.closeButton.style.top = '';
        }

        // フォーカスをドロワー内に移してキーボード操作をしやすくする
        window.requestAnimationFrame(() => {
          this.panel.focus();
        });
      }

      static getVisibleHeaderOffset() {
        var bottom = 0;
        ['.header-wrapper', '.utility-bar'].forEach(function (selector) {
          var el = document.querySelector(selector);
          if (!el) return;
          var rect = el.getBoundingClientRect();
          if (rect.bottom > bottom) bottom = rect.bottom;
        });
        return Math.max(0, Math.min(bottom, window.innerHeight));
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('packaging-drawer-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.focus();
      }
    }
  );
}